<div class="element-column">
  <div class="layout_balance">
    <div class="block-row">
      <!-- 検索ボタン群 -->
      <button id="btn_Search" class="btn-secondary"
        #btn_Search forcedEnabledMode="true" [tabindex]="0" (click)="eventBtnSearch_CLICK.emit()">画像検索</button>

      <div class="column-list">
        <label class="list-input-title">受注コード</label>
        <app-order-code-text-input id="txi_OrderCode" #txi_OrderCode [subid]="'txi_OrderCode'"
          [catalogIDField]="txi_DelivCatalog" [forcedEnabledMode]="'true'" [tabindex]="0"
          [disabled]="!imageInfoListOrderCodeEnabled" [(ngModel)]="imageInfoListOrderCode"
          (ngModelChange)="eventOrderCode_CHANGE.emit()" style="width: max-content;">
        </app-order-code-text-input>
      </div>

      <div class="column-list">
        <label class="list-input-title">配達企画回(翌週)</label>
        <input type="text" id="txi_DelivCatalog" #txi_DelivCatalog
          [readonly]="true" plessInputTextSub [restrict]="'[ -￮]'"
          style="width:7rem;"/>
      </div>

      <button id="btn_UseSearch" class="btn-secondary"
        #btn_UseSearch forcedEnabledMode="none" [tabindex]="0" [disabled]="!btnUseSearchEnabled"
        (click)="eventBtnUseSearch_CLICK.emit()">使用画像選択</button>
    </div>
    <div>
      <label id="lbl_Cnt" class="text-right" textAlign="right">{{imageInfoListCnt}}</label>
      <label>件</label>
    </div>
  </div>

  <!-- 検索結果一覧 -->
  <div id="hli_UseImageList" #hli_UseImageList [tabindex]="0" (wheel)="scrollEvent($event)">
    <ul #useImageGroups [style.white-space]="'nowrap'">
      <li *ngFor="let item of imageInfoList; let i = index;"
        (mousedown)="eventUseImageList_ITEMCLICK.emit({event: $event, index: i, imageInfoList: imageInfoList, useImageGroups: useImageGroups})">
        <app-image-info-renderer1600 [data]="item" [index]="i"></app-image-info-renderer1600>
      </li>
    </ul>
  </div>

  <!-- 選択ボタン群 -->
  <div class="layout_balance">
    <div class="element-row">
      <button id="btn_AllSelect" class="btn-tartiary" #btn_AllSelect
        forcedEnabledMode="none" [disabled]="!btnAllSelectEnabled" (click)="eventAllSelect_CLICK.emit()"
        [tabindex]="-1">全選択</button>
      <button id="btn_AllUnSelect" class="btn-tartiary" #btn_AllUnSelect
        forcedEnabledMode="none" [disabled]="!btnAllUnSelectEnabled" (click)="eventAllUnSelect_CLICK.emit()"
        [tabindex]="-1">全解除</button>
    </div>
    <div class="block-row">
      <app-checkbox-label id="chk_EPS" #chk_EPS [subid]="'chk_EPS'" [label]="'EPSファイル'"
        [selected]="true" [forcedEnabledMode]="'true'" [tabindex]="-1">
      </app-checkbox-label>
      <app-checkbox-label id="chk_PNG" #chk_PNG [subid]="'chk_PNG'" [label]="'PNGファイル'"
        [selected]="true" [forcedEnabledMode]="'true'" [tabindex]="-1">
      </app-checkbox-label>
      <app-checkbox-label id="chk_JPG" #chk_JPG [subid]="'chk_JPG'" [label]="'JPGファイル'"
        [selected]="false" [forcedEnabledMode]="'true'" [tabindex]="-1">
      </app-checkbox-label>
      <button id="btn_ImageOutput" class="btn-secondary" #btn_ImageOutput
        forcedEnabledMode="none" [disabled]="!btnImageOutputEnabled" (click)="eventImageOutput_CLICK.emit()"
        [tabindex]="-1">画像出力</button>
    </div>
  </div>
</div>
